import { useMemo } from 'react';

import { ModuleEntityType } from '~/common/types';
import { DateRangeProvider } from '~/components/DateRangeProvider';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ResponsibleUsersProvider } from '~/components/ResponsibleUsersProvider';
import { ModuleSlotId } from '~/modules';
import { useCompanyDetail, useTabId } from '~/modules/Module.hooks';
import { RouteId } from '~/routes';

import { CompanyDetailHeader } from './CompanyDetailHeader/CompanyDetailHeader';

export const CompanyDetail = () => {
  const { companyId } = useCompanyDetail();
  const { tabId } = useTabId();

  const { modules, tabs } = useModulePageConfig({
    pageId: RouteId.companyDetail(),
    tabId,
  });

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.COMPANY, entityId: companyId }),
    [companyId],
  );

  return (
    <DateRangeProvider>
      <ResponsibleUsersProvider>
        <ModulePage
          header={<CompanyDetailHeader id={companyId} tabs={tabs} />}
          modules={
            <ModuleContextProvider value={contextValue}>
              <ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />
            </ModuleContextProvider>
          }
        />
      </ResponsibleUsersProvider>
    </DateRangeProvider>
  );
};
